import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Table, Button, Menu, Grid } from 'semantic-ui-react';

import cm from 'helpers/commons';
import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};

class StoreList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { limitStoreResult } = this.props;

    let isShow = !cm.valueCheck(limitStoreResult) && limitStoreResult.data.blacklist.length > 0;
    return (
      <Menu vertical className="vendysLeftMenu" fluid>
        <Menu.Item className="top" name="title">
          결제제한된 제휴식당
        </Menu.Item>
        {isShow ? (
          limitStoreResult.data.blacklist.map((data, i) => {
            return (
              <div key={i}>
                <Menu.Item
                  className="store-list-item"
                  name={data.storename}
                  style={{ left: 0, position: 'absolute' }}
                />
                <Menu.Item className="store-list-item" name={data.storecategory} style={{ paddingLeft: '500px' }} />
              </div>
            );
          })
        ) : (
          <Menu.Item className="store-list-item">
            <Grid columns="equal">
              <Grid.Row>
                <Grid.Column>결제 제한된 제휴식당이 없습니다.</Grid.Column>
              </Grid.Row>
            </Grid>
          </Menu.Item>
        )}
      </Menu>
    );
  }
}

StoreList.propTypes = propTypes;
StoreList.defaultProps = defaultProps;

StoreList = connect((state) => ({
  limitStoreResult: state.sikdae.limitStoreResult
}))(StoreList);

export default StoreList;
